/* Progressive enhancements for the default MARIS product page. */
(() => {
  const initReviews = () => {
    if (!document.querySelector('.maris-reference-purchase')) return;
    const widget = document.querySelector('#MainContent .jdgm-review-widget');
    const section = widget?.closest('.shopify-section');
    if (!widget || !section || section.dataset.marisReviewsReady) return;
    const reviews = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!reviews?.querySelector('.jdgm-rev')) return;
    section.dataset.marisReviewsReady = 'true';
    section.classList.add('maris-review-preview');
    section.dataset.marisReviewsExpanded = 'false';
    if (!widget.id) widget.id = 'maris-product-reviews';
    const controls = document.createElement('div');
    controls.className = 'maris-review-controls';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'maris-review-toggle';
    button.setAttribute('aria-controls', widget.id);
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'すべてのレビューを見る →';
    controls.append(button);
    section.append(controls);
    button.addEventListener('click', () => {
      const expanded = section.dataset.marisReviewsExpanded !== 'true';
      section.dataset.marisReviewsExpanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'レビューを折りたたむ' : 'すべてのレビューを見る →';
      // The original Judge.me widget, sorting and pagination remain the only data source.
      widget.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  };
  const start = () => {
    const bar = document.querySelector('.maris-sticky-purchase');
    if (bar) {
      const sectionId = bar.dataset.sectionId;
      const info = document.getElementById(`ProductInfo-${sectionId}`);
      const originalForm = document.getElementById(`product-form-${sectionId}`);
      const originalButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const button = bar.querySelector('button');
      const price = bar.querySelector('[data-sticky-price]');
      const sync = () => {
        const sourcePrice = document.getElementById(`price-${sectionId}`);
        if (sourcePrice && price.innerHTML !== sourcePrice.innerHTML) price.innerHTML = sourcePrice.innerHTML;
        button.disabled = !originalButton || originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
        const label = originalButton?.querySelector('span')?.textContent.trim();
        if (label) button.textContent = label;
        const quantity = document.getElementById(`Quantity-${sectionId}`);
        bar.querySelector('[data-sticky-quantity]').textContent = quantity?.value || '1';
        bar.querySelector('.maris-sticky-purchase__quantity').hidden = !quantity;
      };
      if (info && originalForm && originalButton) {
        // Keep the fixed bar outside ancestors with scroll-animation transforms.
        document.body.append(bar);
        sync();
        new MutationObserver(sync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        info.addEventListener('input', sync);
        info.addEventListener('change', sync);
        // Native form association uses the existing product-form submit handler and quantity.
        button.addEventListener('click', (event) => {
          sync();
          if (button.disabled) event.preventDefault();
        });
        new IntersectionObserver(([entry]) => {
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
          document.body.classList.toggle('maris-sticky-visible', !bar.hidden);
        }).observe(originalButton);
      }
    }
    document.querySelectorAll('.maris-sides-disclosure').forEach((details) => {
      const mobile = window.matchMedia('(max-width: 749px)');
      const sync = () => { details.open = !mobile.matches; };
      sync();
      mobile.addEventListener('change', sync);
      details.querySelector('summary').addEventListener('click', (event) => {
        if (!mobile.matches) event.preventDefault();
      });
    });
    initReviews();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(initReviews).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
